<template>
	<div class="encry-item" v-if="data">
		<!-- 公共头部 -->
		<div class="auther-wrap">
			<div class="img-wrap left">
				<img :src="data.userAvatar" :alt="data.userName" />
			</div>
			<div class="auther-name-wrap left">
				<p class="name-wrap">
					<span class="name yf-text_16 ellipsis"><i class="iconfont icon-sf" :class="`yf-user-type_${data.userType}`"></i> {{ data.userName }}</span>
					<span class="time">{{ data.createdAt }}</span>
				</p>
			</div>
			<div class="action-wrap right">
        <span style="cursor: default;" v-if="!isRoomTeacher">加密观点</span>
        <span class="stop" v-else-if="isStop">已停售</span>
				<span class="unsale" v-else @click="stopSale">停止销售</span>
			</div>
		</div>
		<div class="item-detail">
			<div v-if="data.content" class="view-unlock">
				<p class="unlock-title">
					<i class="iconfont icon-suokai"></i> 此观点{{ data.gcoins }}G币，您已拥有查看权限
				</p>
				<div class="unlock-view rich_text" v-html="switchBody(data.content)"></div>
			</div>
      <div v-else-if="isStop" class="view-out">
        <div class="icon-wrap"><i class="iconfont icon-suo"></i></div>
        <div class="title"><p>此加密观点已下架</p></div>
      </div>
      <div v-else>
        <a class="view-secret">
          <div class="icon-wrap"><i class="iconfont icon-suo"></i></div>
          <div class="secret-hover">
            <p class="pcs" :style="{width: monthGolds > 0 ? '50%' : '100%'}" @click="unlock(1)">解锁单条加密观点：<span>{{ data.gcoins }}</span>G币</p>
            <p v-show="monthGolds > 0" class="month" @click="unlock(2)">订阅观点包：<span>{{ monthGolds }}</span>G币/月
              <em class="right">划算</em>
            </p>
          </div>
        </a>
      </div>
		</div>
	</div>
</template>

<script>
import { switchBody } from '@/utils/Filters'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Dialog from '@/utils/Dialog'

export default {
  name: 'component-room-encrypted-view',
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data () {
    return {
      // 是否停止销售
      isStop: this.data.status === 1
    }
  },
  methods: {
    switchBody,
    // 购买付费观点包 type 1: 单条 2: 包月
  	unlock (type) {
			if (!this.$isLogin()) {
				Dialog.login()
				return
			}
      if (this.isTeacher) {
        Dialog.alert('老师不能购买其他老师的观点哦')
        return
      }
      Dialog.order({
        type: 4,
        title: `${this.data.userName}${this.data.createdAt}加密观点`,
        date: type === 2 ? `${this.data.createdAt.substr(0, 10)} 至 ${moment(this.data.createdAt).add(30, 'd').format('YYYY-MM-DD')} (共30天)` : null,
        price: type === 1 ? this.data.gcoins : this.monthGolds,
        teacher: this.data.userId,
      }, (data, instance) => {
        // 确认订单回调函数
        const params = {
          id: this.data.id,
          type: type,
          voucher_id: data.voucher > 0 ? data.voucher : 0,
          gcoins: data.gcoins
        }
        this.$axios._post('/EncryptedView/Pay', params).then(res => {
          instance.close()
          // 重新加载付费观点数据
          this.$store.dispatch('room/initEncryptedViewList', this.$store.state.room.data.lastTopicId)
        })
      })
  	},
    // 停售付费观点
    stopSale () {
      Dialog.confirm('您确认需要下架此付费观点吗？').then(() => {
        this.$axios._post('/EncryptedView/Stop', { id: this.data.id }).then(() => this.isStop = true)
      })
    }
  },
  computed: {
    // 包月价格
    monthGolds () {
      return this.$store.state.teacher.data.encryptedViewMonth
    },
    ...mapGetters({
      isRoomTeacher: 'room/isTeacher',
      isTeacher: 'user/isTeacher'
    })
  }
}
</script>

<style lang="less" scoped>
.encry-item {
  &:not(:last-child) { 
    margin-bottom: 16px; border-bottom: 1px solid #eee; padding-bottom: 10px;
  }
	.auther-wrap { height: 40px; line-height: 40px; margin: 10px 0 12px;
		.img-wrap { height: 40px;
			img { width: 40px; height: 40px; border-radius: 50%;}
		}
		.auther-name-wrap {
			.name-wrap {
				.name { margin-left: 6px; max-width: 400px; }
				.time { font-size: 14px; color: #999; margin-left: 7px; }
			}
		}
    .action-wrap { width: 80px;
      > span { 
        border: 1px solid #ff775a; display: inline-block; width: 80px; line-height: 20px; text-align: center; color: #ff775a; cursor: pointer; border-radius: 2px;
        &.stop {
          border-color: #999; color: #999; cursor: default;
        }
        &.unsale {
          transition: all .3s;
          &:hover {
            background-color: #ff775a; color: #ffffff;
          }
        }
      }
    }
	}
  .item-detail {
    .view-unlock {
      .unlock-title {
        background: #fd8402; line-height: 30px;  color: #fff; text-indent: 14px;
        i { font-size: 20px; vertical-align: -10%; }
      }
      .unlock-view { background: url(~assets/view-out-bj2.jpg) repeat; padding: 13px 16px; font-size: 14px;
        p { line-height: 20px;}
      }
    }
    .view-out { height: 50px; background: url(~assets/view-out-bj1.jpg) repeat-x;
      .icon-wrap { height: 100%; text-align: center; line-height: 50px; width: 66px; float: left;
        i { font-size: 33px; color: #919191;}
      }
      .title { line-height: 50px; color: #919191; float: left;
        > p { font-size: 14px; color: #949494; }
      }
    }
    > div {
      .view-secret { display: block; height: 50px; background: url(~assets/view-out-bj2.jpg) repeat-x; cursor: pointer; position: relative;
        .icon-wrap { height: 100%; line-height: 50px; width: 66px; text-align: center; float: left;
          i { font-size: 33px; color: #fff;}
        }
        .title { width: 624px; line-height: 50px; color: #646464; float: left;
          > p { font-size: 14px; color: #5d5d5d;}
        }
        .secret-hover { position: absolute; height: 50px; width: 100%; display: none; left: 0; display: block;
          .pcs, .month {width: 50%; float: left; line-height: 50px; color: #fff; text-align: center; font-size: 14px;
            > span { font-size: 20px;}
          }
          .pcs { background: #fd8402;}
          .month {background: #f8512f; overflow: hidden;
            em {display: block; width: 77px;  height: 25px; font-weight: 700; line-height: 25px;  margin-top: 6px; margin-right: -24px; transform: rotate(45deg); background: #fffc00; color: #fc6a31;}
          }
        }
      }
    }
  }
}
</style>
